import OlMap from 'ol/Map'
import { Extent } from 'ol/extent'
import { Geometry } from 'ol/geom'

import { getRoadSegmentFeatureMetadata } from '../../../../layers/roadSegment/roadSegmentFeatureMetadata'
import { findLayer } from '../../../../layers/utils/findLayer'
import { createNonBlockingRenderByTime } from '../../../../renderingQueue'

const nonblockingRender = createNonBlockingRenderByTime()

export async function selectRoadSegmentFeatureInExtent(
  map: OlMap,
  lassoPolygon: Geometry,
  lassoExtent: Extent,
) {
  const roadSegmentLayer = findLayer(map, 'roadSegment')
  const selectedIds: string[] = []

  const featuresInExtent = roadSegmentLayer.getSource()?.getFeaturesInExtent(lassoExtent) ?? []

  nonblockingRender.reset()

  for (const feature of featuresInExtent) {
    await nonblockingRender.next()

    const mode = getRoadSegmentFeatureMetadata(feature, 'mode')
    if (mode === 'off') continue

    const recordId = feature.getId() as string

    if (recordId) {
      const extent = feature.getGeometry()?.getExtent()

      if (extent && lassoPolygon.intersectsExtent(extent)) {
        selectedIds.push(recordId)
      }
    }
  }

  return selectedIds
}
